import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-subscriberdetailsbrief',
  templateUrl: './subscriberdetailsbrief.component.html',
  styleUrls: ['./subscriberdetailsbrief.component.scss']
})
export class SubscriberdetailsbriefComponent {
  subscriberdetailsbrief: any;
  constructor(
    public dialogref: MatDialogRef<SubscriberdetailsbriefComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    debugger
    this.subscriberdetailsbrief = this.data['subscriberbrieflist'];
    console.log(this.subscriberdetailsbrief)
    console.log(this.data)
  }

show=false 

//Old Correct Method
// getStateName(state_name:any){
//   return state_name.map(s => s.state_name).join(', ')
// }

getStateName(state_name: any): string {
  if (!state_name) return '';

  if (Array.isArray(state_name)) {
    return state_name.map((s: any) => s.state_name || s).join(', ');
  }

  if (typeof state_name === 'object') {
    return state_name.state_name || '';
  }

  return state_name.toString();
}


  printPage() {
      this.show = true;
      const printContent = document.getElementById('print-section1')?.outerHTML;
      if (!printContent) {
        console.error("Print section not found!");
        return;
      }
  
      const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
  
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(`
          <html>
            <head>
              <title>Print Report</title>
             <style>
  @media print {
    @page {
      size: A3 landscape;
      margin: 5mm;
    }
  
    html, body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      font-size: 15px;
      line-height: 1.2;
      height: 100%;
    }
  
    table {
      width: 100%;
      min-height: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }
  
    tr {
      page-break-inside: avoid;
    }
  
    th, td {
      padding: 1px;
      border: 1px solid black;
      text-align: center;
      font-size: 14px;
      line-height: 1.2;
      box-sizing: border-box;
    }
  
    .noPrint {
      display: none;
    }
  }
  </style>
  
            </head>
            <body>
              <div id="print-section1">
                ${printContent}
              </div>
              <script>
                window.onload = function() {
                  window.print();
                  setTimeout(() => { window.close(); }, 500);
                };
              </script>
            </body>
          </html>
        `);
        printWindow.document.close();
      } else {
        console.error("Failed to open print window.");
      }
    }
    
  
     exportExcel(fileName): void {
        /* table id is passed over here */
        let element = document.getElementById('print-section1');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, fileName + '.xlsx');
      }
  
}
